<template>
    <div class="landing-page-sell-get-instant-cash">
        <iframe
            class="jot-form"
            onload="window.parent.scrollTo(0,0)"
            allowtransparency="true"
            allowfullscreen="true"
            allow="geolocation"
            :src="url"
        />
    </div>
</template>

<script>
import './GetInstantCash.scss';
import {jotFormUrl} from "../../../../components/helpers/externalRoutes";
import LandingPageAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageAppResource";

export default {
    name: "GetInstantCash",
    props: {
        landingPage: {
            type: LandingPageAppResource,
            required: true,
        },
    },
    data() {
        return {}
    },
    computed: {
        url() {
            return jotFormUrl(window.env.JOTFORM_LANDING_PAGE_SALE_ID, {
                landingPageUuid: this.landingPage.uuid
            })
        }
    },
    methods: {}
}
</script>
